<template>
  <div class="Published-container">
    <div class="head-title">
      <p>已发布的数据资源</p>
    </div>
    <div class="select">
      <div class="select-list">
        <p class="active">全部数据资源</p>
        <p>公开</p>
        <p>私密</p>
        <p>草稿</p>
      </div>
      <div class="select-input">
        <input placeholder="搜索" type="text" />
        <img :src="seach" alt="" />
      </div>
    </div>
    <div class="Datasets">
      <div class="Datasets-head">
        <div class="checkbox-All">
          <el-checkbox v-model="checkAll" @change="hanlecheck"></el-checkbox>
          <p>全选</p>
        </div>
        <div class="Datasets-head-num">2222数据资源</div>
      </div>
      <div class="Datasets-item" v-for="(item, index) in itemList" :key="index">
        <div class="item-check">
          <el-checkbox v-model="itemList[index]"></el-checkbox>
        </div>
        <div class="item-content">
          <div class="img"></div>
          <div class="content-box">
            <div class="conten-box-title">大语言数据资源</div>
            <div class="conten-box-p">
              该数据资源集合了大语言模型所需的XXX, 包含XXXX,
              拥有超过XXXX的使用范例.
            </div>
            <div class="content-iconList">
              <div class="iconlist-item">
                <img :src="wj" alt="" />
                <p>105MB</p>
              </div>
              <div class="iconlist-item">
                <img :src="wj" alt="" />
                <p>105MB</p>
              </div>
              <div class="iconlist-item">
                <img :src="wj" alt="" />
                <p>105MB</p>
              </div>
              <div class="iconlist-item">
                <img :src="wj" alt="" />
                <p>105MB</p>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-list">
          <button class="updatabtn">编辑</button>
          <button class="delbtn">删除</button>
        </div>
      </div>
    </div>
    <div class="pagination">
          <el-pagination
      :current-page="1"
      :page-sizes="[3, 5, 10]"
      :page-size="100"
      layout="total, prev, pager, next,  sizes,jumper"
      :total="400">
    </el-pagination>
    </div>
  </div>
</template>

<script>
import seach from "@/assets1/已发布数据集-已选_slices/搜索.png";
import wj from "@/assets1/已发布数据集-已选_slices/编组 8.png";
export default {
  data() {
    return {
      seach,
      checkAll: false,
      wj,
      itemList: [false, false, false],
    };
  },
  computed: {},
  watch: {
    itemList(newValue) {
      const istrue = Array.from(newValue).every((item) => {
        return item === true;
      });
      if (istrue === true) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
  },
  methods: {
    hanlecheck() {
      if (this.checkAll) {
        this.itemList.forEach((item, index) => {
          this.itemList[index] = true;
        });
      } else {
        this.itemList.forEach((item, index) => {
          this.itemList[index] = false;
        });
      }
    },
  },
};
</script>

<style scoped>
::v-deep .number.active{
    background-color: #0D53FF;
    color: #fff;
    box-sizing: border-box;
}
::v-deep .el-pager .more::before{
    line-height: 18px;
    
}
::v-deep .el-pagination{
    font-size:12px ;
    font-family: Regular;
  box-sizing: border-box;
  width: 100%;
  position: absolute;
  bottom: 25px;
  left:220px ;
}
::v-deep .el-pager li.active+li {
    border-left:1px solid #D9D9D9 ;
}
::v-deep .el-pager li{
    padding: 5px 10px;
    border: 1px solid #D9D9D9;
    border-radius: 4px;
    min-width: auto;
    line-height: normal;
    height: auto;
    margin-right: 8px;
    color: #666666;
 box-sizing: border-box;

}
::v-deep .el-pager li:last-child {
    margin-right: 0;
}
.delbtn {
  background-color: #e92424;
  color: #fff;
}
.updatabtn {
  color: #838690;
  background-color: #fff;
}
.btn-list {
  position: absolute;
  top: 50%;
  right: 0px;
  transform: translateY(-50%);
}
.btn-list button {
  font-size: 14px;
  width: 80px;
  height: 30px;
  font-family: Regular;
  border: 1px solid #cccccc;
  border-radius: 4px;
  margin-right: 15px;
}
.conten-box-p {
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 20px;
}
.conten-box-title {
  margin-bottom: 4px;
  font-size: 16px;
  font-family: Medium;
}
.item-check {
  margin-left: 20px;
}
.img {
  width: 95px;
  height: 95px;
  border-radius: 6px;
  background-color: #d8d8d8;
  flex-shrink: 0;
  margin-left: 20px;
  margin-right: 12px;
}
.iconlist-item {
  display: flex;
  font-size: 12px;
  line-height: 13px;
  margin-right: 25px;
}
.iconlist-item img {
  width: 13px;
  height: 13px;
  object-fit: cover;
  margin-right: 3px;
}
.content-iconList {
  display: flex;
}
.item-content {
  width: 500px;
  display: flex;
}
.Datasets-item {
  width: 100%;
  height: 135px;
  border-radius: 4px;
  border: 1px solid #eee;
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 8px;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #0d53ff;
}
.checkbox-All p {
  margin-left: 20px;
}
.checkbox-All {
  display: flex;
  flex-shrink: 0;

  align-items: center;
}
.checkbox-All {
  display: flex;
  /* color: #0D53FF; */
}
.Datasets-head {
  display: flex;
  justify-content: space-between;
  padding: 19px 20px;
  background-color: #f7f7f7;
  border-radius: 4px;
  margin-bottom: 12px;
}
.Datasets {
  margin-top: 33px;
}
.select-input {
  width: 164px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #cccccc;
  font-family: Regular;
}
.select-input input {
  width: 107px;
  height: 18px;
  margin-right: 17px;
  outline: none;
  border: none;
}
.select-input input::placeholder {
  font-family: Regular;
}
.active {
  color: #0d53ff;
}
.select-list p.active::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: -10px;
  width: 100%;
  height: 2px;
  background-color: #0d53ff;
}
.select-list p {
  margin-right: 50px;
  position: relative;
  font-size: 14px;
}
.select-list {
  display: flex;
  flex-shrink: 0;
}
.select {
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
}
.Published-container {
    height: 100%;
  margin: 24px;
  font-family: Regular;
position: relative;
}
.head-title {
  font-size: 24px;
  font-family: Medium;
  margin-bottom: 24px;
}
</style>